// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1UMuj","validationTips":"StatementDescriptor_validationTips__2Aguy"};